// Calendar maths on "YYYY-MM-DD" strings (the bookings' local_date, already in the tenant's time zone)
const D = (s) => new Date(`${s}T12:00:00Z`);
export const iso = (d) => d.toISOString().slice(0, 10);
export const addDays = (s, n) => { const d = D(s); d.setUTCDate(d.getUTCDate() + n); return iso(d); };
export const monday = (s) => addDays(s, -((D(s).getUTCDay() + 6) % 7));
export const todayIn = (tz) => new Intl.DateTimeFormat("en-CA", { timeZone: tz || "Europe/Rome" }).format(new Date());

export function range(view, anchor) {
  if (view === "day") return [anchor, anchor];
  if (view === "week") { const m = monday(anchor); return [m, addDays(m, 6)]; }
  const first = `${anchor.slice(0, 8)}01`;
  const last = iso(new Date(Date.UTC(+anchor.slice(0, 4), +anchor.slice(5, 7), 0, 12)));
  return [monday(first), addDays(monday(last), 6)];
}

export function step(view, anchor, dir) {
  if (view === "day") return addDays(anchor, dir);
  if (view === "week") return addDays(anchor, 7 * dir);
  const d = new Date(Date.UTC(+anchor.slice(0, 4), +anchor.slice(5, 7) - 1 + dir, 1, 12));
  return iso(d);
}

export const days = (a, b) => { const out = []; for (let d = a; d <= b; d = addDays(d, 1)) out.push(d); return out; };

export function title(view, anchor) {
  const opt = { timeZone: "UTC" };
  if (view === "day") return D(anchor).toLocaleDateString("it-IT", { ...opt, weekday: "long", day: "numeric", month: "long", year: "numeric" });
  if (view === "week") { const [a, b] = range("week", anchor); return `${D(a).toLocaleDateString("it-IT", { ...opt, day: "numeric", month: "short" })} – ${D(b).toLocaleDateString("it-IT", { ...opt, day: "numeric", month: "short", year: "numeric" })}`; }
  return D(anchor).toLocaleDateString("it-IT", { ...opt, month: "long", year: "numeric" });
}

const ACTIVE = ["pending", "awaiting_payment", "confirmed"];
// Overlapping active bookings on the same staff member or resource (capacity per slot is enforced at booking time; this flags manual/legacy overlaps)
export function conflicts(rows) {
  const out = new Set();
  const act = rows.filter((b) => ACTIVE.includes(b.status) && (b.staff_id || b.resource_id));
  act.forEach((a, i) => act.slice(i + 1).forEach((b) => {
    const same = (a.staff_id && a.staff_id === b.staff_id) || (a.resource_id && a.resource_id === b.resource_id);
    if (same && a.start < b.end && b.start < a.end) { out.add(a.id); out.add(b.id); }
  }));
  return out;
}
